import React from "react";
import { Route, Routes } from 'react-router-dom';
import { tabsProps } from "../Tabs";

interface RoutesProps {
    routes: tabsProps[]
}

const CustomRoutes: React.FC<RoutesProps> = ({ routes }) => {

    return <Routes>
        {routes.map((route) => (
            <Route path={route.key + '/*'} element={route.content} />
        ))}
    </Routes>
}

export default CustomRoutes;